export * from './exam-page.component';
